import { createTypedAsyncThunk, withOrgId } from "../utils/actions";
import * as API from "@/data/api/dashboard-slots";
import { RequestParams, TDashboardSlotItem, TDashboardSlotPayload } from "@/data/types";
import { State } from "../state/state";

export const getAllDashboardSlotsAsync = createTypedAsyncThunk<
  { items: TDashboardSlotItem[] },
  RequestParams,
  { state: State }
>("dashboardSlots/getAllDashboardSlots", async (params, { getState }) => {
  return API.getAllDashboardSlots(withOrgId(getState, params));
});

export const createDashboardSlotAsync = createTypedAsyncThunk<
  TDashboardSlotItem,
  { params?: RequestParams; payload: TDashboardSlotPayload },
  { state: State }
>("dashboardSlots/createDashboardSlot", async ({ params = {}, payload }, { getState }) => {
  return API.createDashboardSlot(withOrgId(getState, params), payload);
});

export const getDashboardSlotByIdAsync = createTypedAsyncThunk<
  TDashboardSlotItem,
  { dashboardSlotId: string; params?: RequestParams },
  { state: State }
>("dashboardSlots/getDashboardSlotById", async ({ dashboardSlotId, params = {} }, { getState }) => {
  return API.getDashboardSlotById(dashboardSlotId, withOrgId(getState, params));
});

export const updateDashboardSlotAsync = createTypedAsyncThunk<
  TDashboardSlotItem,
  { dashboardSlotId: string; params?: RequestParams; payload: Partial<TDashboardSlotPayload> },
  { state: State }
>("dashboardSlots/updateDashboardSlot", async ({ dashboardSlotId, params = {}, payload }, { getState }) => {
  return API.updateDashboardSlot(dashboardSlotId, withOrgId(getState, params), payload);
});

export const deleteDashboardSlotAsync = createTypedAsyncThunk<
  { success: boolean },
  { dashboardSlotId: string; params?: RequestParams },
  { state: State }
>("dashboardSlots/deleteDashboardSlot", async ({ dashboardSlotId, params = {} }, { getState }) => {
  return API.deleteDashboardSlot(dashboardSlotId, withOrgId(getState, params));
});